import { DestroyRef, Directive, inject } from '@angular/core';
import { NgProgressRef } from 'ngx-progressbar';
import { ProgressBarService } from './progress-bar.service';

@Directive({
  selector: 'ng-progress[globalProgressBar]',
})
export class GlobalProgressBarDirective {
  constructor() {
    const progressRef = inject(NgProgressRef, { self: true });
    const progressBarService = inject(ProgressBarService);

    progressBarService.register(progressRef);
    inject(DestroyRef).onDestroy(() => progressBarService.unregister(progressRef));
  }
}
